import Vue from 'vue';
import Vuex from 'vuex';
import goodsInfoBanner from './modules/goodsInfoBanner';
import video from './modules/video';
Vue.use(Vuex);

export default new Vuex.Store({
  modules:{
    goodsInfoBanner,
    video
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js